/**
 * @file ai识别模块相关网络请求
 */


import axios from 'axios';

import {
	Message
} from 'element-ui';


import * as constants from '@/tools/constants.js';


import * as tools from '@/tools/tools.js';

import * as utils from '@/tools/utils.js';

const instance = axios.create();


// 调用本地ai服务器的工具方法
const airecogFetchFn = async (options) => {

	let {
		method, // 请求方式 {String}
		temUrl, // 临时的请求地址 一般用来调试 一般用不到
		url, // 请求地址 {String}
		data, // 请求数据 {Object}
		params, // 请求数据 {Object}
		headers, // 请求头 {Object}
		resultDataType, // 返回数据格式默认 Object,
		handleErrFn
	} = options;

	method = method ? method : 'get';
	method = `${method}`.toUpperCase();

	resultDataType = resultDataType ? resultDataType : 'Object';



	handleErrFn = handleErrFn ? handleErrFn : ({
		msg
	}) => {
		Message({
			type: 'error',
			message: `${msg}`
		})
	}

	// 处理可能调试使用的 临时网络地址
	if (temUrl) {
		// 有临时的请求地址 就 用 临时的请求地址
		url = temUrl;
	} else {
		// const host = 'http://aitest.top:9892';
		const host = 'http://127.0.0.1:5567';
		url = `${host}${url}`;
	}

	try {
		const result = await instance({
			timeout: 1000 * 60, // 请求超过60s 自动断开
			method,
			url,
			headers: {
				...headers
			},
			params,
			data: {
				...data,
			},
		});

		/* console.log('airecogFetchFn await instance result', {
			instance,
			result
		}); */

		const code = tools.objectGet(result, 'status');

		const msg = tools.objectGet(result, 'data.message') || result.statusText;


		if (code == 200) {
			const resultObject = {
				code,
				msg,
				networkStatus: constants.networkEnum.networkSuccess,
				data: (() => {
					if (resultDataType == 'Object') {
						return tools.objectGetObject(result, 'data')
					}
					if (resultDataType == 'Array') {
						return tools.objectGetArray(result, 'data')
					}
					return tools.objectGet(result, 'data');
				})(),
			};
			return resultObject;
		} else {
			const resultObject = {
				networkStatus: constants.networkEnum.networkError,
				msg,
				result
			};
			handleErrFn(resultObject)
			return resultObject;
		}
	} catch (e) {
		console.log('airecogFetchFn await instance catch e', e);

		const resultObject = {
			networkStatus: constants.networkEnum.networkError,
			msg: e.message,
			result: e
		};
		handleErrFn(resultObject);
		return resultObject;
	}

}


// 判断业务功能状态是否成功
const checkStatusSuccessFn = data => tools.objectGet(data, 'status') === 0 ? true : false;


// 生成失败信息数据
const createFailInfoFn = data => {
	return {
		networkStatus: constants.networkEnum.networkError,
		data,
		msg: tools.objectGetString(data, 'message')
	}
}





// 初始化接口
export const initAirecogApi = async (that, params) => {
	
	const timeout = 18; // 超时时间 单位是 秒
	
	const startTime = Math.floor(+new Date()/1000);
	
	let success = false;
	
	const isWhileFn = ()=>{
		if(success || Math.floor(+new Date()/1000) - startTime>=timeout){
			return false;
		}
		return true;
	}
	
	while(isWhileFn()){
		
		const result = await airecogFetchFn({
			method: 'post',
			handleErrFn: ()=>{},
			headers: {
				'content-type': 'application/json'
			},
			url: '/cmd',
			data: {
				cmd: 100,
				appAuth: params
			}
		});
		
		console.log('cmd:100 result', result);
		
		
		if (that.checkNetworkSuccessFn(result) && checkStatusSuccessFn(result.data)) {
			success = true;
		}
	}
	console.log('use:time:', Math.floor(+new Date()/1000) - startTime);
	return success;
	
}






// 获取摄像头拍到的base64图像数据
export const cameraBase64ImageApi = async (that) => {

	const result = await airecogFetchFn({
		method: 'post',
		headers: {
			'content-type': 'application/json'
		},
		url: '/cmd',
		data: {
			cmd: 204
		}
	});
	// console.log('cmd:204 result', result);

	if (that.checkNetworkSuccessFn(result)) {
		if (checkStatusSuccessFn(result.data)) {
			return tools.objectGetString(result.data, 'img')
		}
		return createFailInfoFn(result.data);
	}
	return result;
}




// 学习接口
export const learnImageApi = async (that, params) => {
	const result = await airecogFetchFn({
		method: 'post',
		headers: {
			'content-type': 'application/json'
		},
		url: '/cmd',
		data: {
			cmd: 216,
			code: params.code,
			imageFile: params.imageFile
		}
	});
	console.log('cmd:216 result', result);

	if (that.checkNetworkSuccessFn(result)) {
		if (checkStatusSuccessFn(result.data)) {
			return true;
		}
		return createFailInfoFn(result.data);
	}
	return result;
}


// 识别接口
export const execRecogApi = async (that, params) => {
	const result = await airecogFetchFn({
		method: 'post',
		headers: {
			'content-type': 'application/json'
		},
		url: '/cmd',
		data: {
			cmd: 200,
			// topK 合法值 最大是10, 建议5个
			// topK: params,
			withPic: true
		}
	});
	console.log('cmd:200 result', result);

	if (that.checkNetworkSuccessFn(result)) {
		if (checkStatusSuccessFn(result.data)) {
			return {
				image: utils.base64ImagePathFn(tools.objectGetString(result.data, 'img')),
				requestId: tools.objectGetString(result.data, 'requestId'),
				codeList: tools.objectGetArray(result.data, 'data').map(i => ({
					code: i.code,
					confidence: i.confidence
				}))
			}
		}
		return createFailInfoFn(result.data);
	}
	return result;
}


// 反馈
export const feedbackRecogApi = async (requestId, code) => {

	const result = await airecogFetchFn({
		method: 'post',
		headers: {
			'content-type': 'application/json'
		},
		url: '/cmd',
		data: {
			cmd: 201,
			requestId,
			data: {
				code
			}

		}
	});
	console.log('cmd:201 result', result);


	return result;
}


// 查询激活状态
export const checkActiveStateApi = async (that) => {

	const result = await airecogFetchFn({
		method: 'post',
		headers: {
			'content-type': 'application/json'
		},
		url: '/cmd',
		data: {
			cmd: 203,
		}
	});
	console.log('cmd:203 result', result);

	if (that.checkNetworkSuccessFn(result)) {
		return tools.objectGet(result.data, 'status') === 0 ? true : false
	}
	return result;
}




// 查询已学习商品code
export const queryGoodsCodeListApi = async (that) => {

	const result = await airecogFetchFn({
		method: 'post',
		headers: {
			'content-type': 'application/json'
		},
		url: '/cmd',
		data: {
			cmd: 221
		}
	});
	console.log('cmd:221 result', result);

	if (that.checkNetworkSuccessFn(result)) {
		if (checkStatusSuccessFn(result.data)) {
			return tools.objectGetString(result.data, 'products').split(',').filter(i => `${i}`);
		}
		return createFailInfoFn(result.data);
	}
	return result;
}





// 打开ai识别设置页面
export const openAirecogSetApi = async () => {

	const result = await airecogFetchFn({
		method: 'post',
		headers: {
			'content-type': 'application/json'
		},
		url: '/cmd',
		data: {
			cmd: 103
		}
	});
	console.log('cmd:103 result', result);


	return result;
}


// base64图片数据转本地路径
export const base642FilePathApi = async base64Data => {
	let result;
	try {
		result = await instance({
			method: 'post',
			headers: {
				'content-type': 'application/json'
			},
			url: 'http://127.0.0.1:4444/savePic',
			data: {
				base64: utils.base64ImagePathFn(base64Data)
			}
		});
	} catch (e) {
		console.log('/start catch e', e);
		return false;
	}
	console.log('/start result.data', result.data);
	return tools.objectGet(result.data, 'code') === 0 ? tools.objectGetString(result.data, 'data.path') : false;
}


// WEBPACK FOOTER //
// ./src/apis/airecog-apis.js